import React, { useEffect, useRef, useState } from "react";
import ViewLoanDetails from "./ViewLoanDetails";
import { Order } from "../../interface/order";
import { getUserLoanHistory } from "../../services/userService";

export default function LoanContent() {
  const didRun = useRef(false);
  const [orders, setOrders] = useState<Order[]>([]);
  const [showDocumentPopup, setShowDocumentPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  useEffect(() => {
    if (!didRun.current) {
      didRun.current = true;
      getMyOrder();
    }

    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const getMyOrder = async () => {
    try {
      const result = await getUserLoanHistory();
      setOrders(result.message.loan_history);
    } catch (error) {
      console.error("Error in fetching data:", error);
    }
  };

  return (
    <>
    <div className="px-4 py-8 sm:px-6 lg:px-8">
      {/* Desktop Table */}
      <div className="hidden sm:block overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-white">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                Loan Type
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                Loan ID / Lender Name
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                Loan Amount
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                Loan Status
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                EMI Status
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-500">
                Info
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {orders.map((order) => (
              <tr key={order.loan_id}>
                <td className="px-6 py-4 text-sm text-gray-600">{order.isPersonalLoan ? "Personal Loan":"Business Loan"}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{order.loan_id}<br></br>{order.lender_name}</td>
                <td className="px-6 py-4 text-sm text-gray-600">Rs. {order.loan_amount}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{order.amount_status}</td>
                <td className="px-6 py-4 text-sm text-gray-600">{order.emi_status}</td>
                <td className="px-6 py-4 text-sm"
                onClick={() => {
                  setSelectedOrder(order);
                  setShowDocumentPopup(true);
                }}>
                  <a
                    href={order.link}
                    className="text-indigo-600 hover:text-indigo-800 font-medium"
                  >
                    View Details
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="sm:hidden space-y-4">
        {orders.map((order) => (
          <div
            key={order.loan_id}
            className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm"
          >
            <div className="flex items-center gap-4">
              <img
                src="img/personal_loan.png"
                alt={order.lender_name}
                // className="h-16 w-16 rounded-md object-cover"
                className="h-16 w-16 rounded-md object-cover bg-[#1F2937]"
              />
              <div>
                <p className="font-medium text-gray-900">{order.loan_id}</p>
                <p className="text-sm text-gray-600">{order.lender_name}</p>
                <p className="text-sm text-gray-600">Rs. {order.loan_amount}</p>
              </div>
            </div>
            {/* <div className="mt-3 text-sm text-gray-600">{order.loan_id}</div> */}
            {/* <div className="mt-3 text-sm text-gray-600">{order.lender_name}</div> */}
            {/* <div className="mt-3 text-sm text-gray-600">Rs. {order.loan_amount}</div> */}
            <div className="mt-3 text-sm text-gray-600">Loan Status: {order.amount_status}</div>
            <div className="mt-3 text-sm text-gray-600">EMI Status: {order.emi_status}</div>
            <div className="mt-2" 
              onClick={() => {
                  setSelectedOrder(order);
                  setShowDocumentPopup(true);
                }}
              >
              <a
                href={order.link}
                className="text-indigo-600 hover:text-indigo-800 font-medium text-sm"
              >
                View Details
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
    <ViewLoanDetails
      order={selectedOrder}
      open={showDocumentPopup}
      onClose={() => setShowDocumentPopup(false)}
    />
    </>
  );
}
